import React from 'react';
import { hasRole } from '../utils/authUtils';

interface ProtectedContentProps {
  children: React.ReactNode;
  requiredRoles: string[];
  fallback?: React.ReactNode;
  requireAll?: boolean;
}

/**
 * Component that conditionally renders content based on user roles
 * @param children - Content to render if user has required permissions
 * @param requiredRoles - Array of roles that grant access to the content
 * @param fallback - Optional content to render if user doesn't have permissions
 * @param requireAll - If true, user must have ALL roles. If false (default), user needs ANY role
 */
const ProtectedContent: React.FC<ProtectedContentProps> = ({
  children,
  requiredRoles,
  fallback = null,
  requireAll = false
}) => {
  if (!requiredRoles || requiredRoles.length === 0) {
    // If no roles specified, render children by default
    return <>{children}</>;
  }

  const hasAccess = requireAll 
    ? requiredRoles.every(role => hasRole([role]))
    : hasRole(requiredRoles);

  if (hasAccess) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default ProtectedContent;